import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { ConfigService } from '../service/config.service';

@Injectable({
  providedIn: 'root',
})
export class SignupAccessGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly configService: ConfigService,
  ) {}

  canActivate(): boolean | UrlTree {
    const config = this.ensureConfig();
    return this.isSignupAndProfilingEnabled(config)
      ? true
      : this.router.createUrlTree(['/404']);
  }

  private ensureConfig(): any {
    const currentConfig = this.configService.getConfig();
    if (currentConfig && Object.keys(currentConfig).length > 0) {
      return currentConfig;
    }
    return this.configService.getConfigFromStorage() ?? {};
  }

  private isSignupAndProfilingEnabled(config: any): boolean {
    const value = config?.signupAndProfilingEnabled;
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return value.toString().toLowerCase() === 'true';
  }
}
